<template>
  <tab-test v-if="loaded"/>
  <error-view v-else-if="error" :error="error" @reload="load"/>
  <vpreloader v-else/>
</template>
<script>

  import {createNamespacedHelpers} from 'vuex';
  import store from './stores.js';
  import TabTest from './controllers/tab-test';
  import ErrorView from '@/process/_components/error-view';
  const {mapActions, mapGetters} = createNamespacedHelpers('feniche_response_tab_test');

  export default {
    name: 'feniche-response-tab-test-index',
    components: {
      TabTest,
      ErrorView,
    },
    mixins: [store],
    props: {
      responseToken: {
        type: String,
        default: null,
      }
    },
    computed: {
      ...mapGetters(['loaded', 'error'])
    },
    methods: {
      ...mapActions(['load'])
    },
    beforeMount () {
      this.load(this.responseToken);
    }
  }
</script>